import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsMobileDetect } from "../../hooks";
import { Angle } from "../Angle/Angle";
import { Compass } from "../Compas/Compass";
import { CurrentSpeedIndicator } from "../CurrentSpeedIndicator/CurrentSpeedIndicator";
export const DirectionController = ({ controlData, currentSpeed, angles }) => {
    const { isStraightFull, isBackFull, isTurnLeft, isTurnRight, isArrowStraight, isArrowBack, isArrowRight, isArrowLeft, isStopActive, isArmed, onStraightTouchStart, onStraightTouchEnd, onRightTouchStart, onRightTouchEnd, onBackTouchStart, onBackTouchEnd, onLeftTouchStart, onLeftTouchEnd, onTurnLeftTouchStart, onTurnLeftTouchEnd, onTurnRightTouchStart, onTurnRightTouchEnd, onFullForwardTouchStart, onFullForwardTouchEnd, onFullBackwardTouchStart, onFullBackwardTouchEnd, } = controlData;
    const isMobilePortrait = useIsMobileDetect();
    const arrowStraitTouchStart = () => {
        isArmed < 0 && onStraightTouchStart(); //goForward(0);
    };
    const arrowStraitTouchEnd = () => {
        isArmed < 0 && onStraightTouchEnd(); //stop();
    };
    const arrowRightTouchStart = () => {
        isArmed < 0 && onRightTouchStart(); //turnRight();
    };
    const arrowRightTouchEnd = () => {
        isArmed < 0 && onRightTouchEnd(); //endTurnRight();
    };
    const arrowBackTouchStart = () => {
        isArmed < 0 && onBackTouchStart(); //goBackward(0);
    };
    const arrowBackTouchEnd = () => {
        isArmed < 0 && onBackTouchEnd(); //stop();
    };
    const arrowLeftTouchStart = () => {
        isArmed < 0 && onLeftTouchStart(); //turnLeft();
    };
    const arrowLeftTouchEnd = () => {
        isArmed < 0 && onLeftTouchEnd(); //endTurnLeft();
    };
    const turnLeftTouchStart = () => {
        isArmed < 0 && onTurnLeftTouchStart(); //spotTurnLeft();
    };
    const turnLeftTouchEnd = () => {
        isArmed < 0 && onTurnLeftTouchEnd(); //stop();
    };
    const turnRightTouchStart = () => {
        isArmed < 0 && onTurnRightTouchStart(); //spotTurnRight();
    };
    const turnRightTouchEnd = () => {
        isArmed < 0 && onTurnRightTouchEnd(); //stop();
    };
    const fullSpeedAheadTouchStart = () => {
        isArmed < 0 && onFullForwardTouchStart(); //forceForward();
    };
    const fullSpeedAheadTouchStop = () => {
        isArmed < 0 && onFullForwardTouchEnd(); //stopForceForward();
    };
    const fullSpeedBackTouchStart = () => {
        isArmed < 0 && onFullBackwardTouchStart(); //forceBackward();
    };
    const fullSpeedBackTouchStop = () => {
        isArmed < 0 && onFullBackwardTouchEnd(); //stopForceBackward();
    };
    return (_jsxs("div", { className: "direction-control", children: [_jsxs("div", { className: "controller-rotation", children: [_jsx("div", { onTouchStart: turnLeftTouchStart, onTouchEnd: turnLeftTouchEnd, className: isTurnLeft
                            ? "controller-rotation-left active"
                            : "controller-rotation-left" }), _jsx("div", { className: "controller-direction-wrapper", children: _jsxs("div", { className: "controller-direction-arrows", children: [isStraightFull ? (_jsx("div", { className: "arrow controller-direction-straight active full" })) : (_jsx("div", { onTouchStart: arrowStraitTouchStart, onTouchEnd: arrowStraitTouchEnd, className: isArrowStraight
                                        ? "arrow controller-direction-straight active"
                                        : "arrow controller-direction-straight" })), _jsx("div", { onTouchStart: arrowRightTouchStart, onTouchEnd: arrowRightTouchEnd, className: isArrowRight
                                        ? "arrow controller-direction-right active"
                                        : "arrow controller-direction-right" }), isBackFull ? (_jsx("div", { className: "arrow controller-direction-back active full" })) : (_jsx("div", { onTouchStart: arrowBackTouchStart, onTouchEnd: arrowBackTouchEnd, className: isArrowBack
                                        ? "arrow controller-direction-back active"
                                        : "arrow controller-direction-back" })), _jsx("div", { onTouchStart: arrowLeftTouchStart, onTouchEnd: arrowLeftTouchEnd, className: isArrowLeft
                                        ? "arrow controller-direction-left active"
                                        : "arrow controller-direction-left" }), _jsx("div", { className: isStopActive ? "drone-action active" : "drone-action" })] }) }), _jsx("div", { onTouchStart: turnRightTouchStart, onTouchEnd: turnRightTouchEnd, className: isTurnRight
                            ? "controller-rotation-right active"
                            : "controller-rotation-right" }), _jsxs("div", { className: "controller-full-speed", children: [_jsx("div", { onTouchStart: fullSpeedAheadTouchStart, onTouchEnd: fullSpeedAheadTouchStop, className: isStraightFull
                                    ? "controller-full-speed-ahead active"
                                    : "controller-full-speed-ahead" }), _jsx("div", { onTouchStart: fullSpeedBackTouchStart, onTouchEnd: fullSpeedBackTouchStop, className: isBackFull
                                    ? "controller-full-speed-back active"
                                    : "controller-full-speed-back" })] })] }), _jsx(CurrentSpeedIndicator, { speed: currentSpeed }), !isMobilePortrait && Boolean(angles[0] && angles[1]) && (_jsx(Angle, { tiltLR: angles[1], tiltFB: angles[0] })), !isMobilePortrait && Boolean(angles[2]) && (_jsx(Compass, { heading: angles[2] }))] }));
};
